// src/components/Layout.jsx
import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import { useSidebar } from "./SidebarContext";
import { Menu } from "lucide-react";
import logo from "../components/assets/images/logo.png";

function Layout() {
  const [user, setUser] = useState(null);
  const { setMobileOpen } = useSidebar();

  useEffect(() => {
    fetch("https://api.sobevenda.com.br/api-proxy/affiliate/auth/me", {
      headers: { Authorization: `Bearer ${localStorage.getItem("sobevenda_token")}` },
    })
      .then((res) => res.json())
      .then((data) => setUser(data))
      .catch(() => setUser(null));
  }, []);

  const planLabel = user?.plan
    ? `Plano ${user.plan.charAt(0).toUpperCase() + user.plan.slice(1)}`
    : "";

  return (
    <div className="min-h-screen bg-[rgb(var(--bg))] text-[rgb(var(--fg))]">
      <Sidebar />

      {/* Topbar mobile — slate-100 para combinar com o sidebar */}
      <header className="md:hidden fixed top-0 left-0 right-0 z-20 h-16
        bg-slate-100 border-b border-slate-200
        dark:bg-slate-900 dark:border-slate-800
        flex items-center justify-between px-4">

        <button
          onClick={() => setMobileOpen(true)}
          className="flex items-center justify-center w-10 h-10 rounded-lg border border-slate-200 dark:border-slate-700 text-slate-500 dark:text-slate-400 hover:bg-white dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-slate-100 transition"
          aria-label="Abrir menu"
        >
          <Menu className="w-5 h-5" />
        </button>

        <div className="absolute left-1/2 -translate-x-1/2 flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-white shadow-sm flex items-center justify-center shrink-0">
            <img src={logo} alt="SobeVenda" className="w-8 h-8 object-contain" />
          </div>
          <div>
            <div className="text-sm font-extrabold text-slate-900 dark:text-slate-100 leading-tight">SobeVenda</div>
            {planLabel && <div className="text-[10px] text-slate-400 dark:text-slate-500 leading-tight">{planLabel}</div>}
          </div>
        </div>

        <div className="w-10" />
      </header>

      <main className="min-h-screen p-6 pt-20 md:pt-6 bg-[rgb(var(--bg))] transition-all duration-300 md:ml-[var(--sidebar-width,18rem)]">
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;